import styled from "styled-components";
import { COLOUR_CONSTANT } from "../../utils/contants";

export const ResourceHeaderStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${COLOUR_CONSTANT.theme.purple.medium};
  padding: 8px 0;

  .heading-content {
    display: flex;
    align-items: center;
    gap: 7px;
  }

  .text-flex {
    display: flex;
    flex-direction: column;
    .MuiTypography-root {
      line-height: 140%;
    }
  }
`;
